// Floating "Feedback" button on every page: captures what's on screen and
// opens the request form with it ready to mark up.
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FeedbackModal from "./FeedbackModal";
import { captureViewport } from "./captureScreen";

export default function FeedbackButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [shot, setShot] = useState(undefined); // undefined = closed
  const [sentId, setSentId] = useState(null);

  const pageUrl = location.pathname + location.search;

  const open = async () => {
    setBusy(true);
    setSentId(null);
    let image = null;
    try {
      image = await captureViewport();
    } catch (e) {
      // Fall through to paste/upload; the form still works without a capture.
      console.warn("Screen capture failed:", e);
    }
    setBusy(false);
    setShot(image);
  };

  return (
    <>
      <div data-html2canvas-ignore="true"
        style={{ position: "fixed", right: 20, bottom: 20, zIndex: 1500, display: "flex", gap: 8, alignItems: "center" }}>
        {sentId && (
          <button type="button" onClick={() => { setSentId(null); navigate(`/improvements/${sentId}`); }}
            style={{
              background: "#ecfdf5", color: "#047857", border: "1px solid #a7f3d0", borderRadius: 999,
              padding: "8px 14px", fontSize: 13, cursor: "pointer", boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}>
            Request #{sentId} sent. View it →
          </button>
        )}
        <button
          type="button"
          onClick={open}
          disabled={busy}
          title="Suggest an improvement to this screen"
          style={{
            background: "#4f46e5", color: "#fff", border: "none", borderRadius: 999,
            padding: "10px 16px", fontWeight: 600, fontSize: 14, cursor: busy ? "wait" : "pointer",
            boxShadow: "0 6px 18px rgba(79,70,229,0.35)",
          }}
        >
          {busy ? "Capturing…" : "💬 Feedback"}
        </button>
      </div>
      {shot !== undefined && (
        <FeedbackModal
          initialImage={shot}
          pageUrl={pageUrl}
          onClose={() => setShot(undefined)}
          onCreated={(item) => {
            setShot(undefined);
            setSentId(item.id);
            window.dispatchEvent(new CustomEvent("feedback-changed"));
          }}
        />
      )}
    </>
  );
}
